import IOrderItem from "@/module/main/dto/financing-v3/IOrderItem";
import IAmount from "@/module/main/dto/IAmount";
import IFileData from "@/module/main/dto/financing-v3/IFileData";
import OrderItemType from "@/module/main/dto/customer/OrderItemTypeEnum";

export default class OrderItem implements IOrderItem
{
    public readonly code?: string;
    public readonly image?: IFileData;
    public readonly name?: string;
    public readonly producer?: string;
    public readonly quantity?: number;
    public readonly totalPrice?: IAmount;
    public readonly type?: OrderItemType;

    constructor(props: IOrderItem)
    {
        this.code = props.code;
        this.image = props.image;
        this.name = props.name;
        this.producer = props.producer;
        this.quantity = props.quantity;
        this.totalPrice = props.totalPrice;
        this.type = props.type;
    }
}
